// Component Type Model
export interface ComponentType {
    label: string;
    value: string;
}

// Component types - currently only Emerald is supported
export const componentTypes: readonly ComponentType[] = Object.freeze([{ label: 'Emerald', value: 'emerald' }]);
